import { useEffect, useRef } from 'react';

const useScrollAnimation = (pathname) => {
  const animatedElements = useRef(new Set());

  useEffect(() => {
    animatedElements.current.clear();
  }, [pathname]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !animatedElements.current.has(entry.target)) {
            animatedElements.current.add(entry.target);
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.scroll-animate, .scroll-animate-left, .scroll-animate-right, .scroll-animate-scale');

    // Observe elements and immediately check if they're already in view
    elements.forEach(el => {
      observer.observe(el);

      // For elements already visible on page load, add the visible class immediately
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        animatedElements.current.add(el);
        el.classList.add('visible');
      }
    });

    return () => observer.disconnect();
  }, [pathname]);
};

export default useScrollAnimation;
